export default __webpack_public_path__ + "pdf/CV-2024.475f0b3a.pdf";